import { createFileRoute } from '@tanstack/react-router';
import { PageSkeleton } from '@/components/ui/page-skeleton';

export const Route = createFileRoute('/admin/seguridad/organizaciones')({
  pendingComponent: PageSkeleton,
});
